import PropTypes from "prop-types";

import CheckedIcon from "assets/svg/checkbox-checked.svg";
import UncheckedIcon from "assets/svg/checkbox-unchecked.svg";
import ErrorIcon from "assets/svg/checkbox-error.svg";

import styles from "./styles.module.css";

const CheckboxWithLink = ({ hasError, isChecked, onCheckboxChange, onModalOpen }) => {
  const handleLinkClick = (event) => {
    event.stopPropagation();
    onModalOpen();
  };

  const handleCheckboxIconClick = (event) => {
    event.stopPropagation();
    onCheckboxChange();
  };

  return (
    <div className={styles.container}>
      <input type="checkbox" checked={isChecked} onChange={onCheckboxChange} className={styles.checkboxInput} />
      <div className={styles.checkboxIcon} onClick={handleCheckboxIconClick}>
        {hasError ? <ErrorIcon /> : isChecked ? <CheckedIcon /> : <UncheckedIcon />}
      </div>
      <p className={styles.text} onClick={onCheckboxChange}>
        Kişisel verilerin işlenmesiyle ilgili{" "}
        <span className={styles.link} onClick={handleLinkClick}>
          Aydınlatma Metni
        </span>
        &apos;ni okuyup anladığımı beyan ve kabul ederim.
      </p>
    </div>
  );
};

CheckboxWithLink.propTypes = {
  hasError: PropTypes.bool,
  isChecked: PropTypes.bool,
  onCheckboxChange: PropTypes.func.isRequired,
  onModalOpen: PropTypes.func.isRequired,
};

export default CheckboxWithLink;
